import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
	cloneSettingsRole,
	deleteSettingsRole,
	getSettingsRoles,
} from '../../../../../../services/settings/users';

export default function UseRoles() {
	const [rolesList, setRolesList] = useState([]);
	const [loader, setLoder] = useState(false);
	const [sortDirection, setSortDirection] = useState(false);
	const [params, setParams] = useState({
		pageSize: 10000,
		page: 1,
		orderBy: '',
		sortBy: '',
		filterBy: '',
		filterValue: '',
	});
	const sortDataList = (param) => {
		const newDirection = sortDirection[param.order_by] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.order_by]: newDirection });
		setParams((prev) => ({
			...prev,
			orderBy: param.order_by,
			sortBy: newDirection,
		}));
	};
	const handleDeleteRole = async (id) => {
		try {
			const res = await deleteSettingsRole(id);
			if (res.success) {
				toast.success(res.message);
				getRolesList();
			} else {
				toast.error(res.message);
			}
		} catch (error) {
			toast.error(error.message || 'something went wrong!');
		}
	};
	const handleCloneRole = async (roleId) => {
		try {
			var body = {
				id: roleId,
			};
			const res = await cloneSettingsRole(body);
			if (res.success) {
				toast.success(res.message);
				getRolesList();
			} else {
				toast.error(res.message);
			}
		} catch (error) {
			toast.error(error.message || 'something went wrong!');
		}
	};

	function mappedTableData(data) {
		return data?.map((ele) => {
			return {
				id: ele.id,
				role_name: ele.name,
				description: ele.description,
				action: JSON.stringify({
					id: ele.id,
				}),
			};
		});
	}

	const getRolesList = async () => {
		try {
			setLoder(true);
			const { roles } = await getSettingsRoles(params);
			const data = mappedTableData(roles);
			setRolesList(data);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		} finally {
			setLoder(false);
		}
	};
	useEffect(() => {
		getRolesList();
	}, [params]);
	return {
		getRolesList,
		rolesList,
		sortDataList,
		sortDirection,
		loader,
		handleCloneRole,
		handleDeleteRole,
	};
}
